export const countryCodes = [
  'al',
  'ad',
  'am',
  'at',
  'az',
  'by',
  'be',
  'ba',
  'bg',
  'hr',
  'cy',
  'cz',
  'dk',
  'ee',
  'fi',
  'fr',
  'ge',
  'de',
  'gr',
  'hu',
  'is',
  'ie',
  'it',
  'kz',
  'lv',
  'li',
  'lt',
  'lu',
  'mt',
  'md',
  'mc',
  'me',
  'nl',
  'mk',
  'no',
  'pl',
  'pt',
  'ro',
  'ru',
  'sm',
  'rs',
  'sk',
  'si',
  'es',
  'se',
  'ch',
  'tr',
  'ua',
  'gb',
  'va',
]

export const countryCodesWithName = {
  AF: 'Afghanistan',
  AL: 'Albania',
  DZ: 'Algeria',
  AS: 'American Samoa',
  AD: 'Andorra',
  AO: 'Angola',
  AI: 'Anguilla',
  AQ: 'Antarctica',
  AG: 'Antigua and Barbuda',
  AR: 'Argentina',
  AM: 'Armenia',
  AW: 'Aruba',
  AU: 'Australia',
  AT: 'Austria',
  AZ: 'Azerbaijan',
  BS: 'Bahamas (the)',
  BH: 'Bahrain',
  BD: 'Bangladesh',
  BB: 'Barbados',
  BY: 'Belarus',
  BE: 'Belgium',
  BZ: 'Belize',
  BJ: 'Benin',
  BM: 'Bermuda',
  BT: 'Bhutan',
  BO: 'Bolivia (Plurinational State of)',
  BQ: 'Bonaire, Sint Eustatius and Saba',
  BA: 'Bosnia and Herzegovina',
  BW: 'Botswana',
  BV: 'Bouvet Island',
  BR: 'Brazil',
  IO: 'British Indian Ocean Territory (the)',
  BN: 'Brunei Darussalam',
  BG: 'Bulgaria',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  CV: 'Cabo Verde',
  KH: 'Cambodia',
  CM: 'Cameroon',
  CA: 'Canada',
  KY: 'Cayman Islands (the)',
  CF: 'Central African Republic (the)',
  TD: 'Chad',
  CL: 'Chile',
  CN: 'China',
  CX: 'Christmas Island',
  CC: 'Cocos (Keeling) Islands (the)',
  CO: 'Colombia',
  KM: 'Comoros (the)',
  CD: 'Congo (the Democratic Republic of the)',
  CG: 'Congo (the)',
  CK: 'Cook Islands (the)',
  CR: 'Costa Rica',
  HR: 'Croatia',
  CU: 'Cuba',
  CW: 'Curaçao',
  CY: 'Cyprus',
  CZ: 'Czechia',
  CI: "Côte d'Ivoire",
  DK: 'Denmark',
  DJ: 'Djibouti',
  DM: 'Dominica',
  DO: 'Dominican Republic (the)',
  EC: 'Ecuador',
  EG: 'Egypt',
  SV: 'El Salvador',
  GQ: 'Equatorial Guinea',
  ER: 'Eritrea',
  EE: 'Estonia',
  SZ: 'Eswatini',
  ET: 'Ethiopia',
  FK: 'Falkland Islands (the) [Malvinas]',
  FO: 'Faroe Islands (the)',
  FJ: 'Fiji',
  FI: 'Finland',
  FR: 'France',
  GF: 'French Guiana',
  PF: 'French Polynesia',
  TF: 'French Southern Territories (the)',
  GA: 'Gabon',
  GM: 'Gambia (the)',
  GE: 'Georgia',
  DE: 'Germany',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GR: 'Greece',
  GL: 'Greenland',
  GD: 'Grenada',
  GP: 'Guadeloupe',
  GU: 'Guam',
  GT: 'Guatemala',
  GG: 'Guernsey',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HT: 'Haiti',
  HM: 'Heard Island and McDonald Islands',
  VA: 'Holy See (the)',
  HN: 'Honduras',
  HK: 'Hong Kong',
  HU: 'Hungary',
  IS: 'Iceland',
  IN: 'India',
  ID: 'Indonesia',
  IR: 'Iran (Islamic Republic of)',
  IQ: 'Iraq',
  IE: 'Ireland',
  IM: 'Isle of Man',
  IL: 'Israel',
  IT: 'Italy',
  JM: 'Jamaica',
  JP: 'Japan',
  JE: 'Jersey',
  JO: 'Jordan',
  KZ: 'Kazakhstan',
  KE: 'Kenya',
  KI: 'Kiribati',
  KP: "Korea (the Democratic People's Republic of)",
  KR: 'Korea (the Republic of)',
  KW: 'Kuwait',
  KG: 'Kyrgyzstan',
  LA: "Lao People's Democratic Republic (the)",
  LV: 'Latvia',
  LB: 'Lebanon',
  LS: 'Lesotho',
  LR: 'Liberia',
  LY: 'Libya',
  LI: 'Liechtenstein',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  MO: 'Macao',
  MG: 'Madagascar',
  MW: 'Malawi',
  MY: 'Malaysia',
  MV: 'Maldives',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Marshall Islands (the)',
  MQ: 'Martinique',
  MR: 'Mauritania',
  MU: 'Mauritius',
  YT: 'Mayotte',
  MX: 'Mexico',
  FM: 'Micronesia (Federated States of)',
  MD: 'Moldova (the Republic of)',
  MC: 'Monaco',
  MN: 'Mongolia',
  ME: 'Montenegro',
  MS: 'Montserrat',
  MA: 'Morocco',
  MZ: 'Mozambique',
  MM: 'Myanmar',
  NA: 'Namibia',
  NR: 'Nauru',
  NP: 'Nepal',
  NL: 'Netherlands (the)',
  NC: 'New Caledonia',
  NZ: 'New Zealand',
  NI: 'Nicaragua',
  NE: 'Niger (the)',
  NG: 'Nigeria',
  NU: 'Niue',
  NF: 'Norfolk Island',
  MP: 'Northern Mariana Islands (the)',
  NO: 'Norway',
  OM: 'Oman',
  PK: 'Pakistan',
  PW: 'Palau',
  PS: 'Palestine, State of',
  PA: 'Panama',
  PG: 'Papua New Guinea',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Philippines (the)',
  PN: 'Pitcairn',
  PL: 'Poland',
  PT: 'Portugal',
  PR: 'Puerto Rico',
  QA: 'Qatar',
  MK: 'Republic of North Macedonia',
  RO: 'Romania',
  RU: 'Russian Federation (the)',
  RW: 'Rwanda',
  RE: 'Réunion',
  BL: 'Saint Barthélemy',
  SH: 'Saint Helena, Ascension and Tristan da Cunha',
  KN: 'Saint Kitts and Nevis',
  LC: 'Saint Lucia',
  MF: 'Saint Martin (French part)',
  PM: 'Saint Pierre and Miquelon',
  VC: 'Saint Vincent and the Grenadines',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'Sao Tome and Principe',
  SA: 'Saudi Arabia',
  SN: 'Senegal',
  RS: 'Serbia',
  SC: 'Seychelles',
  SL: 'Sierra Leone',
  SG: 'Singapore',
  SX: 'Sint Maarten (Dutch part)',
  SK: 'Slovakia',
  SI: 'Slovenia',
  SB: 'Solomon Islands',
  SO: 'Somalia',
  ZA: 'South Africa',
  GS: 'South Georgia and the South Sandwich Islands',
  SS: 'South Sudan',
  ES: 'Spain',
  LK: 'Sri Lanka',
  SD: 'Sudan (the)',
  SR: 'Suriname',
  SJ: 'Svalbard and Jan Mayen',
  SE: 'Sweden',
  CH: 'Switzerland',
  SY: 'Syrian Arab Republic',

  TJ: 'Tajikistan',
  TZ: 'Tanzania, United Republic of',
  TH: 'Thailand',
  TL: 'Timor-Leste',
  TG: 'Togo',
  TK: 'Tokelau',
  TO: 'Tonga',
  TT: 'Trinidad and Tobago',
  TN: 'Tunisia',
  TR: 'Turkey',
  TM: 'Turkmenistan',
  TC: 'Turks and Caicos Islands (the)',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ukraine',
  AE: 'United Arab Emirates (the)',
  GB: 'United Kingdom of Great Britain and Northern Ireland (the)',
  UM: 'United States Minor Outlying Islands (the)',
  US: 'United States of America (the)',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VU: 'Vanuatu',
  VE: 'Venezuela (Bolivarian Republic of)',
  VN: 'Viet Nam',
  VG: 'Virgin Islands (British)',
  VI: 'Virgin Islands (U.S.)',
  WF: 'Wallis and Futuna',
  EH: 'Western Sahara',
  YE: 'Yemen',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
  AX: 'Åland Islands',
}

export const countryCodesWithNameCs = {
  AF: 'Afghánistán',
  AL: 'Albánie',
  DZ: 'Alžírsko',
  AS: 'Americká Samoa',
  AD: 'Andorra',
  AO: 'Angola',
  AI: 'Anguilla',
  AQ: 'Antarktida',
  AG: 'Antigua a Barbuda',
  AR: 'Argentina',
  AM: 'Arménie',
  AW: 'Aruba',
  AU: 'Austrálie',
  AT: 'Rakousko',
  AZ: 'Ázerbájdžán',
  BS: 'Bahamy',
  BH: 'Bahrajn',
  BD: 'Bangladéš',
  BB: 'Barbados',
  BY: 'Bělorusko',
  BE: 'Belgie',
  BZ: 'Belize',
  BJ: 'Benin',
  BM: 'Bermudy',
  BT: 'Bhútán',
  BO: 'Bolívie',
  BQ: 'Bonaire, Sint Eustatius a Saba',
  BA: 'Bosna a Hercegovina',
  BW: 'Botswana',
  BV: 'Bouvetův ostrov',
  BR: 'Brazílie',
  IO: 'Britské indickooceánské území',
  BN: 'Brunej',
  BG: 'Bulharsko',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  CV: 'Kapverdy',
  KH: 'Kambodža',
  CM: 'Kamerun',
  CA: 'Kanada',
  KY: 'Kajmanské ostrovy',
  CF: 'Středoafrická republika',
  TD: 'Čad',
  CL: 'Chile',
  CN: 'Čína',
  CX: 'Vánoční ostrov',
  CC: 'Kokosové ostrovy',
  CO: 'Kolumbie',
  KM: 'Komory',
  CD: 'Demokratická republika Kongo',
  CG: 'Kongo',
  CK: 'Cookovy ostrovy',
  CR: 'Kostarika',
  HR: 'Chorvatsko',
  CU: 'Kuba',
  CW: 'Curaçao',
  CY: 'Kypr',
  CZ: 'Česká republika',
  CI: 'Pobřeží slonoviny',
  DK: 'Dánsko',
  DJ: 'Džibutsko',
  DM: 'Dominika',
  DO: 'Dominikánská republika',
  EC: 'Ekvádor',
  EG: 'Egypt',
  SV: 'Salvador',
  GQ: 'Rovníková Guinea',
  ER: 'Eritrea',
  EE: 'Estonsko',
  SZ: 'Eswatini',
  ET: 'Etiopie',
  FK: 'Falklandské ostrovy',
  FO: 'Faerské ostrovy',
  FJ: 'Fidži',
  FI: 'Finsko',
  FR: 'Francie',
  GF: 'Francouzská Guyana',
  PF: 'Francouzská Polynésie',
  TF: 'Francouzská jižní území',
  GA: 'Gabon',
  GM: 'Gambie',
  GE: 'Gruzie',
  DE: 'Německo',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GR: 'Řecko',
  GL: 'Grónsko',
  GD: 'Grenada',
  GP: 'Guadeloupe',
  GU: 'Guam',
  GT: 'Guatemala',
  GG: 'Guernsey',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HT: 'Haiti',
  HM: 'Heardův ostrov a McDonaldovy ostrovy',
  VA: 'Vatikán',
  HN: 'Honduras',
  HK: 'Hongkong',
  HU: 'Maďarsko',
  IS: 'Island',
  IN: 'Indie',
  ID: 'Indonésie',
  IR: 'Írán',
  IQ: 'Irák',
  IE: 'Irsko',
  IM: 'Ostrov Man',
  IL: 'Izrael',
  IT: 'Itálie',
  JM: 'Jamajka',
  JP: 'Japonsko',
  JE: 'Jersey',
  JO: 'Jordánsko',
  KZ: 'Kazachstán',
  KE: 'Keňa',
  KI: 'Kiribati',
  KP: 'Severní Korea',
  KR: 'Jižní Korea',
  KW: 'Kuvajt',
  KG: 'Kyrgyzstán',
  LA: 'Laos',
  LV: 'Lotyšsko',
  LB: 'Libanon',
  LS: 'Lesotho',
  LR: 'Libérie',
  LY: 'Libye',
  LI: 'Lichtenštejnsko',
  LT: 'Litva',
  LU: 'Lucembursko',
  MO: 'Macao',
  MG: 'Madagaskar',
  MW: 'Malawi',
  MY: 'Malajsie',
  MV: 'Maledivy',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Marshallovy ostrovy',
  MQ: 'Martinik',
  MR: 'Mauritánie',
  MU: 'Mauricius',
  YT: 'Mayotte',
  MX: 'Mexiko',
  FM: 'Mikronésie',
  MD: 'Moldavsko',
  MC: 'Monako',
  MN: 'Mongolsko',
  ME: 'Černá Hora',
  MS: 'Montserrat',
  MA: 'Maroko',
  MZ: 'Mosambik',
  MM: 'Myanmar',
  NA: 'Namibie',
  NR: 'Nauru',
  NP: 'Nepál',
  NL: 'Nizozemsko',
  NC: 'Nová Kaledonie',
  NZ: 'Nový Zéland',
  NI: 'Nikaragua',
  NE: 'Niger',
  NG: 'Nigérie',
  NU: 'Niue',
  NF: 'Norfolk',
  MP: 'Severní Mariany',
  NO: 'Norsko',
  OM: 'Omán',
  PK: 'Pákistán',
  PW: 'Palau',
  PS: 'Palestina',
  PA: 'Panama',
  PG: 'Papua-Nová Guinea',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Filipíny',
  PN: 'Pitcairn',
  PL: 'Polsko',
  PT: 'Portugalsko',
  PR: 'Portoriko',
  QA: 'Katar',
  MK: 'Severní Makedonie',
  RO: 'Rumunsko',
  RU: 'Rusko',
  RW: 'Rwanda',
  RE: 'Réunion',
  BL: 'Saint-Barthélemy',
  SH: 'Svatá Helena, Ascension a Tristan da Cunha',
  KN: 'Svatý Kryštof a Nevis',
  LC: 'Svatá Lucie',
  MF: 'Saint-Martin',
  PM: 'Saint-Pierre a Miquelon',
  VC: 'Svatý Vincenc a Grenadiny',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'Svatý Tomáš a Princův ostrov',
  SA: 'Saúdská Arábie',
  SN: 'Senegal',
  RS: 'Srbsko',
  SC: 'Seychely',
  SL: 'Sierra Leone',
  SG: 'Singapur',
  SX: 'Sint Maarten',
  SK: 'Slovensko',
  SI: 'Slovinsko',
  SB: 'Šalomounovy ostrovy',
  SO: 'Somálsko',
  ZA: 'Jižní Afrika',
  GS: 'Jižní Georgie a Jižní Sandwichovy ostrovy',
  SS: 'Jižní Súdán',
  ES: 'Španělsko',
  LK: 'Srí Lanka',
  SD: 'Súdán',
  SR: 'Surinam',
  SJ: 'Špicberky a Jan Mayen',
  SE: 'Švédsko',
  CH: 'Švýcarsko',
  SY: 'Sýrie',
  TW: 'Tchaj-wan',
  TJ: 'Tádžikistán',
  TZ: 'Tanzanie',
  TH: 'Thajsko',
  TL: 'Východní Timor',
  TG: 'Togo',
  TK: 'Tokelau',
  TO: 'Tonga',
  TT: 'Trinidad a Tobago',
  TN: 'Tunisko',
  TR: 'Turecko',
  TM: 'Turkmenistán',
  TC: 'Turks a Caicos',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ukrajina',
  AE: 'Spojené arabské emiráty',
  GB: 'Spojené království',
  UM: 'Menší odlehlé ostrovy USA',
  US: 'Spojené státy americké',
  UY: 'Uruguay',
  UZ: 'Uzbekistán',
  VU: 'Vanuatu',
  VE: 'Venezuela',
  VN: 'Vietnam',
  VG: 'Britské Panenské ostrovy',
  VI: 'Americké Panenské ostrovy',
  WF: 'Wallis a Futuna',
  EH: 'Západní Sahara',
  YE: 'Jemen',
  ZM: 'Zambie',
  ZW: 'Zimbabwe',
  AX: 'Ålandské ostrovy',
}

export const countryCodesWithNamePl = {
  AF: 'Afganistan',
  AL: 'Albania',
  DZ: 'Algieria',
  AS: 'Samoa Amerykańskie',
  AD: 'Andora',
  AO: 'Angola',
  AI: 'Anguilla',
  AQ: 'Antarktyka',
  AG: 'Antigua i Barbuda',
  AR: 'Argentyna',
  AM: 'Armenia',
  AW: 'Aruba',
  AU: 'Australia',
  AT: 'Austria',
  AZ: 'Azerbejdżan',
  BS: 'Bahamy',
  BH: 'Bahrajn',
  BD: 'Bangladesz',
  BB: 'Barbados',
  BY: 'Białoruś',
  BE: 'Belgia',
  BZ: 'Belize',
  BJ: 'Benin',
  BM: 'Bermudy',
  BT: 'Bhutan',
  BO: 'Boliwia',
  BQ: 'Bonaire, Sint Eustatius i Saba',
  BA: 'Bośnia i Hercegowina',
  BW: 'Botswana',
  BV: 'Wyspa Bouvet',
  BR: 'Brazylia',
  IO: 'Brytyjskie Terytorium Oceanu Indyjskiego',
  BN: 'Brunei',
  BG: 'Bułgaria',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  CV: 'Republika Zielonego Przylądka',
  KH: 'Kambodża',
  CM: 'Kamerun',
  CA: 'Kanada',
  KY: 'Kajmany',
  CF: 'Republika Środkowoafrykańska',
  TD: 'Czad',
  CL: 'Chile',
  CN: 'Chiny',
  CX: 'Wyspa Bożego Narodzenia',
  CC: 'Wyspy Kokosowe',
  CO: 'Kolumbia',
  KM: 'Komory',
  CD: 'Demokratyczna Republika Konga',
  CG: 'Kongo',
  CK: 'Wyspy Cooka',
  CR: 'Kostaryka',
  HR: 'Chorwacja',
  CU: 'Kuba',
  CW: 'Curaçao',
  CY: 'Cypr',
  CZ: 'Czechy',
  CI: 'Wybrzeże Kości Słoniowej',
  DK: 'Dania',
  DJ: 'Dżibuti',
  DM: 'Dominika',
  DO: 'Dominikana',
  EC: 'Ekwador',
  EG: 'Egipt',
  SV: 'Salwador',
  GQ: 'Gwinea Równikowa',
  ER: 'Erytrea',
  EE: 'Estonia',
  SZ: 'Eswatini',
  ET: 'Etiopia',
  FK: 'Falklandy',
  FO: 'Wyspy Owcze',
  FJ: 'Fidżi',
  FI: 'Finlandia',
  FR: 'Francja',
  GF: 'Gujana Francuska',
  PF: 'Polinezja Francuska',
  TF: 'Francuskie Terytoria Południowe',
  GA: 'Gabon',
  GM: 'Gambia',
  GE: 'Gruzja',
  DE: 'Niemcy',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GR: 'Grecja',
  GL: 'Grenlandia',
  GD: 'Grenada',
  GP: 'Gwadelupa',
  GU: 'Guam',
  GT: 'Gwatemala',
  GG: 'Guernsey',
  GN: 'Gwinea',
  GW: 'Gwinea Bissau',
  GY: 'Gujana',
  HT: 'Haiti',
  HM: 'Wyspy Heard i McDonalda',
  VA: 'Watykan',
  HN: 'Honduras',
  HK: 'Hongkong',
  HU: 'Węgry',
  IS: 'Islandia',
  IN: 'Indie',
  ID: 'Indonezja',
  IR: 'Iran',
  IQ: 'Irak',
  IE: 'Irlandia',
  IM: 'Wyspa Man',
  IL: 'Izrael',
  IT: 'Włochy',
  JM: 'Jamajka',
  JP: 'Japonia',
  JE: 'Jersey',
  JO: 'Jordania',
  KZ: 'Kazachstan',
  KE: 'Kenia',
  KI: 'Kiribati',
  KP: 'Korea Północna',
  KR: 'Korea Południowa',
  KW: 'Kuwejt',
  KG: 'Kirgistan',
  LA: 'Laos',
  LV: 'Łotwa',
  LB: 'Liban',
  LS: 'Lesotho',
  LR: 'Liberia',
  LY: 'Libia',
  LI: 'Liechtenstein',
  LT: 'Litwa',
  LU: 'Luksemburg',
  MO: 'Makau',
  MG: 'Madagaskar',
  MW: 'Malawi',
  MY: 'Malezja',
  MV: 'Malediwy',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Wyspy Marshalla',
  MQ: 'Martynika',
  MR: 'Mauretania',
  MU: 'Mauritius',
  YT: 'Majotta',
  MX: 'Meksyk',
  FM: 'Mikronezja',
  MD: 'Mołdawia',
  MC: 'Monako',
  MN: 'Mongolia',
  ME: 'Czarnogóra',
  MS: 'Montserrat',
  MA: 'Maroko',
  MZ: 'Mozambik',
  MM: 'Myanmar',
  NA: 'Namibia',
  NR: 'Nauru',
  NP: 'Nepal',
  NL: 'Holandia',
  NC: 'Nowa Kaledonia',
  NZ: 'Nowa Zelandia',
  NI: 'Nikaragua',
  NE: 'Niger',
  NG: 'Nigeria',
  NU: 'Niue',
  NF: 'Norfolk',
  MP: 'Mariany Północne',
  NO: 'Norwegia',
  OM: 'Oman',
  PK: 'Pakistan',
  PW: 'Palau',
  PS: 'Palestyna',
  PA: 'Panama',
  PG: 'Papua-Nowa Gwinea',
  PY: 'Paragwaj',
  PE: 'Peru',
  PH: 'Filipiny',
  PN: 'Pitcairn',
  PL: 'Polska',
  PT: 'Portugalia',
  PR: 'Portoryko',
  QA: 'Katar',
  MK: 'Macedonia Północna',
  RO: 'Rumunia',
  RU: 'Rosja',
  RW: 'Rwanda',
  RE: 'Reunion',
  BL: 'Saint-Barthélemy',
  SH: 'Święta Helena, Wyspa Wniebowstąpienia i Tristan da Cunha',
  KN: 'Saint Kitts i Nevis',
  LC: 'Saint Lucia',
  MF: 'Saint-Martin',
  PM: 'Saint-Pierre i Miquelon',
  VC: 'Saint Vincent i Grenadyny',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'Wyspy Świętego Tomasza i Książęca',
  SA: 'Arabia Saudyjska',
  SN: 'Senegal',
  RS: 'Serbia',
  SC: 'Seszele',
  SL: 'Sierra Leone',
  SG: 'Singapur',
  SX: 'Sint Maarten',
  SK: 'Słowacja',
  SI: 'Słowenia',
  SB: 'Wyspy Salomona',
  SO: 'Somalia',
  ZA: 'Republika Południowej Afryki',
  GS: 'Georgia Południowa i Sandwich Południowy',
  SS: 'Sudan Południowy',
  ES: 'Hiszpania',
  LK: 'Sri Lanka',
  SD: 'Sudan',
  SR: 'Surinam',
  SJ: 'Svalbard i Jan Mayen',
  SE: 'Szwecja',
  CH: 'Szwajcaria',
  SY: 'Syria',
  TW: 'Tajwan',
  TJ: 'Tadżykistan',
  TZ: 'Tanzania',
  TH: 'Tajlandia',
  TL: 'Timor Wschodni',
  TG: 'Togo',
  TK: 'Tokelau',
  TO: 'Tonga',
  TT: 'Trynidad i Tobago',
  TN: 'Tunezja',
  TR: 'Turcja',
  TM: 'Turkmenistan',
  TC: 'Turks i Caicos',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ukraina',
  AE: 'Zjednoczone Emiraty Arabskie',
  GB: 'Wielka Brytania',
  UM: 'Dalekie Wyspy Mniejsze Stanów Zjednoczonych',
  US: 'Stany Zjednoczone',
  UY: 'Urugwaj',
  UZ: 'Uzbekistan',
  VU: 'Vanuatu',
  VE: 'Wenezuela',
  VN: 'Wietnam',
  VG: 'Brytyjskie Wyspy Dziewicze',
  VI: 'Wyspy Dziewicze Stanów Zjednoczonych',
  WF: 'Wallis i Futuna',
  EH: 'Sahara Zachodnia',
  YE: 'Jemen',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
  AX: 'Wyspy Alandzkie',
}

export const countryCodesWithNameDe = {
  AF: 'Afghanistan',
  AL: 'Albanien',
  DZ: 'Algerien',
  AS: 'Amerikanisch-Samoa',
  AD: 'Andorra',
  AO: 'Angola',
  AI: 'Anguilla',
  AQ: 'Antarktika',
  AG: 'Antigua und Barbuda',
  AR: 'Argentinien',
  AM: 'Armenien',
  AW: 'Aruba',
  AU: 'Australien',
  AT: 'Österreich',
  AZ: 'Aserbaidschan',
  BS: 'Bahamas',
  BH: 'Bahrain',
  BD: 'Bangladesch',
  BB: 'Barbados',
  BY: 'Belarus',
  BE: 'Belgien',
  BZ: 'Belize',
  BJ: 'Benin',
  BM: 'Bermuda',
  BT: 'Bhutan',
  BO: 'Bolivien',
  BQ: 'Bonaire, Sint Eustatius und Saba',
  BA: 'Bosnien und Herzegowina',
  BW: 'Botswana',
  BV: 'Bouvetinsel',
  BR: 'Brasilien',
  IO: 'Britisches Territorium im Indischen Ozean',
  BN: 'Brunei Darussalam',
  BG: 'Bulgarien',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  CV: 'Kap Verde',
  KH: 'Kambodscha',
  CM: 'Kamerun',
  CA: 'Kanada',
  KY: 'Kaimaninseln',
  CF: 'Zentralafrikanische Republik',
  TD: 'Tschad',
  CL: 'Chile',
  CN: 'China',
  CX: 'Weihnachtsinsel',
  CC: 'Kokosinseln',
  CO: 'Kolumbien',
  KM: 'Komoren',
  CD: 'Demokratische Republik Kongo',
  CG: 'Kongo',
  CK: 'Cookinseln',
  CR: 'Costa Rica',
  HR: 'Kroatien',
  CU: 'Kuba',
  CW: 'Curaçao',
  CY: 'Zypern',
  CZ: 'Tschechien',
  CI: 'Elfenbeinküste',
  DK: 'Dänemark',
  DJ: 'Dschibuti',
  DM: 'Dominica',
  DO: 'Dominikanische Republik',
  EC: 'Ecuador',
  EG: 'Ägypten',
  SV: 'El Salvador',
  GQ: 'Äquatorialguinea',
  ER: 'Eritrea',
  EE: 'Estland',
  SZ: 'Eswatini',
  ET: 'Äthiopien',
  FK: 'Falklandinseln',
  FO: 'Färöer',
  FJ: 'Fidschi',
  FI: 'Finnland',
  FR: 'Frankreich',
  GF: 'Französisch-Guayana',
  PF: 'Französisch-Polynesien',
  TF: 'Französische Süd- und Antarktisgebiete',
  GA: 'Gabun',
  GM: 'Gambia',
  GE: 'Georgien',
  DE: 'Deutschland',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GR: 'Griechenland',
  GL: 'Grönland',
  GD: 'Grenada',
  GP: 'Guadeloupe',
  GU: 'Guam',
  GT: 'Guatemala',
  GG: 'Guernsey',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HT: 'Haiti',
  HM: 'Heard und McDonaldinseln',
  VA: 'Heiliger Stuhl',
  HN: 'Honduras',
  HK: 'Hongkong',
  HU: 'Ungarn',
  IS: 'Island',
  IN: 'Indien',
  ID: 'Indonesien',
  IR: 'Iran',
  IQ: 'Irak',
  IE: 'Irland',
  IM: 'Insel Man',
  IL: 'Israel',
  IT: 'Italien',
  JM: 'Jamaika',
  JP: 'Japan',
  JE: 'Jersey',
  JO: 'Jordanien',
  KZ: 'Kasachstan',
  KE: 'Kenia',
  KI: 'Kiribati',
  KP: 'Nordkorea',
  KR: 'Südkorea',
  KW: 'Kuwait',
  KG: 'Kirgisistan',
  LA: 'Laos',
  LV: 'Lettland',
  LB: 'Libanon',
  LS: 'Lesotho',
  LR: 'Liberia',
  LY: 'Libyen',
  LI: 'Liechtenstein',
  LT: 'Litauen',
  LU: 'Luxemburg',
  MO: 'Macao',
  MG: 'Madagaskar',
  MW: 'Malawi',
  MY: 'Malaysia',
  MV: 'Malediven',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Marshallinseln',
  MQ: 'Martinique',
  MR: 'Mauretanien',
  MU: 'Mauritius',
  YT: 'Mayotte',
  MX: 'Mexiko',
  FM: 'Mikronesien',
  MD: 'Moldau',
  MC: 'Monaco',
  MN: 'Mongolei',
  ME: 'Montenegro',
  MS: 'Montserrat',
  MA: 'Marokko',
  MZ: 'Mosambik',
  MM: 'Myanmar',
  NA: 'Namibia',
  NR: 'Nauru',
  NP: 'Nepal',
  NL: 'Niederlande',
  NC: 'Neukaledonien',
  NZ: 'Neuseeland',
  NI: 'Nicaragua',
  NE: 'Niger',
  NG: 'Nigeria',
  NU: 'Niue',
  NF: 'Norfolkinsel',
  MP: 'Nördliche Marianen',
  NO: 'Norwegen',
  OM: 'Oman',
  PK: 'Pakistan',
  PW: 'Palau',
  PS: 'Palästina',
  PA: 'Panama',
  PG: 'Papua-Neuguinea',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Philippinen',
  PN: 'Pitcairninseln',
  PL: 'Polen',
  PT: 'Portugal',
  PR: 'Puerto Rico',
  QA: 'Katar',
  MK: 'Nordmazedonien',
  RO: 'Rumänien',
  RU: 'Russland',
  RW: 'Ruanda',
  RE: 'Réunion',
  BL: 'Saint-Barthélemy',
  SH: 'St. Helena, Ascension und Tristan da Cunha',
  KN: 'St. Kitts und Nevis',
  LC: 'St. Lucia',
  MF: 'Saint-Martin',
  PM: 'St. Pierre und Miquelon',
  VC: 'St. Vincent und die Grenadinen',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'São Tomé und Príncipe',
  SA: 'Saudi-Arabien',
  SN: 'Senegal',
  RS: 'Serbien',
  SC: 'Seychellen',
  SL: 'Sierra Leone',
  SG: 'Singapur',
  SX: 'Sint Maarten',
  SK: 'Slowakei',
  SI: 'Slowenien',
  SB: 'Salomonen',
  SO: 'Somalia',
  ZA: 'Südafrika',
  GS: 'Südgeorgien und die Südlichen Sandwichinseln',
  SS: 'Südsudan',
  ES: 'Spanien',
  LK: 'Sri Lanka',
  SD: 'Sudan',
  SR: 'Suriname',
  SJ: 'Svalbard und Jan Mayen',
  SE: 'Schweden',
  CH: 'Schweiz',
  SY: 'Syrien',
  TW: 'Taiwan',
  TJ: 'Tadschikistan',
  TZ: 'Tansania',
  TH: 'Thailand',
  TL: 'Timor-Leste',
  TG: 'Togo',
  TK: 'Tokelau',
  TO: 'Tonga',
  TT: 'Trinidad und Tobago',
  TN: 'Tunesien',
  TR: 'Türkei',
  TM: 'Turkmenistan',
  TC: 'Turks- und Caicosinseln',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ukraine',
  AE: 'Vereinigte Arabische Emirate',
  GB: 'Vereinigtes Königreich',
  UM: 'Kleinere Inselbesitzungen der Vereinigten Staaten',
  US: 'Vereinigte Staaten',
  UY: 'Uruguay',
  UZ: 'Usbekistan',
  VU: 'Vanuatu',
  VE: 'Venezuela',
  VN: 'Vietnam',
  VG: 'Britische Jungferninseln',
  VI: 'Amerikanische Jungferninseln',
  WF: 'Wallis und Futuna',
  EH: 'Westsahara',
  YE: 'Jemen',
  ZM: 'Sambia',
  ZW: 'Simbabwe',
  AX: 'Ålandinseln',
}
